import { bugsnagApiKey } from './environment.bugsnagApiKey';

export const environment = {
    name: 'test',
    apiUrl: 'https://menu-api.cfamenutest.cfadevelop.com',
    lambdaGatewayUrl: 'https://rds-refresh.cfamenutest.cfadevelop.com',
    menuGatewayUrl: 'https://menu-gateway.cfamenutest.cfadevelop.com',
    backgroundColor: 'yellow',
    oktaDetails: {
        appName: 'Chick-fil-A',
        clientId: '0oaic9fbi72PKJn0U0h7',
        idmUrl: 'https://auth.idm-test.cfadevelop.com/oauth2/token',
        oktaIssuerUrl: 'https://cfahome.oktapreview.com/oauth2/auscjsakz3PaAP82K0h7',
        oktaUrl: 'https://cfahome.oktapreview.com',
        redirectUrl: 'https://menu.cfamenutest.cfadevelop.com/login/callback'
    },
    production: false,
    bugsnagApiKey,
    LDClientId: '6549ad6e769c7312b71147b4',
    reactUrl: 'https://menu-ui-test.vercel-builds.cfadevelop.com',
};
